import { __generator } from "tslib";
import { put, takeLatest, call, select } from 'redux-saga/effects';
import { requestSuccess, requestFailure, clickWatch } from './actionCreators';
import { RequestError } from './types';
import { request } from '../../xhr';
import { getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { isGroup } from '../../User/helpers';
import { toggleWatchGroup } from '../../NetworkBar/redux/actions';
export function fakeResponse() {
    return { success: true };
}
function getError(result) {
    if (result &&
        result.error_code !== undefined &&
        RequestError[result.error_code] !== undefined) {
        return result.error_code;
    }
    return RequestError.GeneralError;
}
export function toggleWatch(_a) {
    var apiMethod, loggedIn, result, newIsWatching;
    var _b = _a.payload, user = _b.user, isWatching = _b.isWatching, onToggleWatchSuccess = _b.onToggleWatchSuccess;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiMethod = isWatching ? 'unwatch' : 'watch';
                return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                loggedIn = _c.sent();
                if (!!loggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.WATCH }))];
            case 2:
                _c.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: apiMethod,
                    data: { username: user.username },
                }, fakeResponse)];
            case 4:
                result = _c.sent();
                if (!(result && result.success)) return [3 /*break*/, 8];
                newIsWatching = !isWatching;
                return [4 /*yield*/, put(requestSuccess(user.username, newIsWatching))];
            case 5:
                _c.sent();
                if (!isGroup(user)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(toggleWatchGroup(user.userId, newIsWatching))];
            case 6:
                _c.sent();
                _c.label = 7;
            case 7:
                onToggleWatchSuccess && onToggleWatchSuccess(newIsWatching);
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put(requestFailure(user.username, getError(result)))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(clickWatch, toggleWatch)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default saga;
//# sourceMappingURL=saga.js.map